<template>
  <div class="content home-page history-page">
    <Header></Header>
    <div class="tool-back" @click="back">
      <img src="../../static/images/back.png" />
    </div>
    <main class="history-page-content crfff">
      <h1>{{ $t('History') }}</h1>
      <section class="history-day" v-for="(items, date) in list" :key="date">
        <h2>{{ date }}</h2>
        <div class="history-grid">
          <article class="history-item" v-for="(item, index) in items" :key="index">
            <div class="history-card process" v-if="item.status=='process'">{{ $t('process') }}</div>
            <button class="history-card" type="button" v-else @click="getLink(item)">
              <span class="history-video-badge" v-if="item.format=='video'">{{ $t('VIDEO') }}</span>
              <video v-if="item.format=='video'" :src="item.image_path" muted playsinline preload="metadata"></video>
              <img v-else :src="item.image_path" loading="lazy"/>
              <span class="history-open"><img src="../../static/images/big.png"/></span>
            </button>
          </article>
        </div>
      </section>
      <div class="history-empty" v-if="!Object.keys(list).length">{{ $t('History') }}</div>
    </main>
    <Dialog class="result-image-dialog history-result-dialog" ref="imgDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true">
      <div class="alert-modal" slot="mdBox">
        <div class="close" @click="closeTmgDialog" style="text-align: right;margin: 0 auto;font-size: 2rem;">×</div>
        <div class="image ac">
          <div class="history-download-tip">{{ isAndroidWebView() ? $t('downTips1') : $t('downloadImageTips') }}</div>

          <div v-if="format=='video'">
                <video class="history-modal-preview" :src="previewUrl" controls preload="metadata"></video>
          </div>
          <div class="" v-else>
            <img class="history-modal-preview" :src="previewUrl"/>
          </div>

          <div class="img-tools" v-if="isAndroidWebView()">
            <div class="ac mt20">
              <div class="input-item mt50 history-download-url">
                <div class="input-item2">
                  <input class="input" :value="downloadUrl" disabled placeholder="">
                </div>
              </div>
              <button class="button fw7" style="width: 100%;font-size: 1rem" v-if="downloadUrl" @click="copy" id="copycode"
                      :data-clipboard-text="downloadUrl">{{ $t('copyLink') }}
                <img style="width: 1.2rem"  src="../../static/images/copy1.png"/>
              </button>
            </div>
          </div>
          <div class="history-direct-download" v-else>
            <button class="button fw7" v-if="downloadUrl" @click="downloadMedia">{{ $t('downloadImage') }}</button>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import Header from '../components/Header'
import Clipboard from 'clipboard';
import Dialog from '../components/dialog'

export default {
  components: {
    Header,
    Dialog
  },
  data() {
    return {
      list: [],
      imageShow: false,
      previewUrl: '',
      downloadUrl: '',
      format:"",
    }
  },
  created() {
    this.getHome();
  },
  methods: {
    getLink(item) {
      this.format = item.format
      this.previewUrl = item.image_path
      this.downloadUrl = item.download_url || item.image_path
      this.$refs.imgDialog.showMaskFun();
    },

    closeTmgDialog() {
      this.previewUrl = ""
      this.downloadUrl = ""
      this.format = ""
      this.$refs.imgDialog.closeMask();
    },
    downloadMedia() {
      if (!this.downloadUrl) return
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = this.downloadUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    isAndroidWebView() {
      const ua = navigator.userAgent || ''
      if (!/Android/i.test(ua)) return false

      const hasWebViewMarkers = /\bwv\b/.test(ua) || /; wv\)/.test(ua) || /WebView/.test(ua) || /XWEB_/.test(ua)
      const isNormalBrowser = /Chrome\/[.0-9]+ Mobile Safari\/[.0-9]+/.test(ua) && !/; wv\)/.test(ua)
      const isTrustedBrowser = /VivoBrowser|MiuiBrowser|HuaweiBrowser/i.test(ua)
      return !isNormalBrowser && !isTrustedBrowser && (hasWebViewMarkers || !/Chrome\//.test(ua))
    },
    back() {
      this.$router.go(-1);
    },
    copy() {
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$utils.alertText(this.$t('CopySucceeded'));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        //console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    getHome() {
      let that = this;
      that.$parent.loadModal(true);
      that.$api.post('/api/user/history', null, r => {
        that.$parent.returnCode(r, function () {
          that.list = r.data
          that.$parent.loadModal(false);
        });

      })

    },
  }
}
</script>
<style>
.history-page { min-height: 100%; padding-bottom: 1.2rem; }
.history-page-content { width: 90%; max-width: 27rem; margin: 0 auto; }
.history-page-content h1 { margin: 0 0 0.8rem; text-align: center; font-size: 1.45rem; line-height: 1.2; }
.history-day + .history-day { margin-top: 1rem; }
.history-day h2 { margin: 0 0 0.45rem; font-size: 0.9rem; color: #fff; }
.history-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 0.35rem; }
.history-item { min-width: 0; }
.history-card { position: relative; display: block; width: 100%; aspect-ratio: 3 / 4; overflow: hidden; border: 0.01rem solid rgba(255,255,255,.7); border-radius: 0.3rem; background: #06105a; padding: 0; color: #fff; }
.history-card:not(.process) { cursor: pointer; }
.history-card > img { display: block; width: 100%; height: 100%; object-fit: cover; }
.history-card > video { display: block; width: 100%; height: 100%; object-fit: cover; }
.history-video-badge { position: absolute; z-index: 2; top: 0.25rem; right: 0.25rem; padding: 0.1rem 0.3rem; border-radius: 0.5rem; background: rgba(0,0,0,.65); color: #fff; font-size: 0.55rem; }
.history-open { position: absolute; right: 0; bottom: 0; left: 0; display: flex; align-items: center; justify-content: center; height: 1.35rem; background: rgba(25,38,107,.88); }
.history-open img { width: 0.9rem; }
.process {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(102,120,218,.55);
}
.history-empty { padding: 2rem 0; text-align: center; color: rgba(255,255,255,.75); }
.history-download-tip { margin-bottom: 0.55rem; font-size: 1rem; line-height: 1.3; }
.history-modal-preview { display: block; width: auto; max-width: 90%; max-height: 36vh; margin: 0 auto; object-fit: contain; }
.history-download-url { width: 80%; margin-bottom: 0.5rem !important; }
.history-direct-download { margin-top: 0.6rem; }
.history-direct-download .button { width: 100%; font-size: 1rem; }
</style>



// WEBPACK FOOTER //
// src/page/history.vue